"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createStore_1 = __importDefault(require("./createStore"));
const createStore_2 = require("./createStore");
const GroupAccountsActions_1 = __importDefault(require("../actions/GroupAccountsActions"));
const GroupAccountsSource_1 = __importDefault(require("../sources/GroupAccountsSource"));
const Account_1 = __importDefault(require("../models/Account"));
const Month_1 = __importDefault(require("../models/Month"));
const AccountNumberTag_1 = __importDefault(require("../models/AccountNumberTag"));
const FlattenAccountData_1 = require("../../utilities/FlattenAccountData");
const TagCategoryActions_1 = __importDefault(require("../actions/TagCategoryActions"));
const TagCategory_1 = __importDefault(require("../models/TagCategory"));
const AccountNumberTagUtils_1 = require("../../utilities/AccountNumberTagUtils");
class GroupAccountsStore extends createStore_2.BaseStore {
    constructor() {
        super();
        this.accountsData = [];
        this.tagCategories = [];
        this.aggregatedData = {
            months: [],
            accountNumberTags: [],
        };
    }
    getActionsHandlers() {
        return {
            receivedAccounts: GroupAccountsActions_1.default.receivedAccounts,
            loadingAccounts: GroupAccountsActions_1.default.loadingAccounts,
            fetchingAccountsFailed: GroupAccountsActions_1.default.fetchingAccountsFailed,
            receivedMonths: GroupAccountsActions_1.default.receivedMonths,
            loadingMonths: GroupAccountsActions_1.default.loadingMonths,
            fetchingMonthsFailed: GroupAccountsActions_1.default.fetchingMonthsFailed,
            receivedAccountNumberTags: GroupAccountsActions_1.default.receivedAccountNumberTags,
            loadingAccountNumberTags: GroupAccountsActions_1.default.loadingAccountNumberTags,
            fetchingAccountNumberTagsFailed: GroupAccountsActions_1.default.fetchingAccountNumberTagsFailed,
            receivedTagCategories: TagCategoryActions_1.default.receivedItems,
        };
    }
    getState() {
        return this;
    }
    getPublicMethods() {
        return {
            getAccounts: () => this.accountsData.map(accountData => accountData.account),
            hasLinkedData: () => this.aggregatedData.months.length >= 13,
            getAccountsWithData: () => this.getAccountsWithData(),
        };
    }
    getSource() {
        return GroupAccountsSource_1.default;
    }
    getAccountsWithData() {
        return this.accountsData.filter(data => data.flattenedMonths.length > 12 && data.accountNumberTags.length > 0);
    }
    receivedAccounts(data) {
        this.accountsData = data.map(item => ({
            account: new Account_1.default(item),
            accountId: new Account_1.default(item).id,
            months: [],
            accountNumberTags: [],
            flattenedMonths: [],
            flattenedAccountNumberTags: [],
        }));
    }
    flattenAccount(accountData) {
        if (accountData.months.length === 0 || accountData.accountNumberTags.length === 0) {
            return;
        }
        if (this.tagCategories.length === 0) {
            throw new Error('tag categories are not initialised');
        }
        const data = (0, FlattenAccountData_1.flattenAccountData)(accountData.account, accountData.months, this.tagCategories);
        accountData.flattenedMonths = data.months;
        accountData.flattenedAccountNumberTags = data.accountNumberTags;
    }
    generateAggregateData() {
        const data = (0, FlattenAccountData_1.generateAggregateData)(this.getAccountsWithData().map(accountData => ({
            account: accountData.account,
            months: accountData.flattenedMonths,
            accountNumberTags: accountData.flattenedAccountNumberTags,
        })), this.tagCategories);
        this.aggregatedData = data;
    }
    loadingAccounts() { }
    fetchingAccountsFailed(errorMessage) {
        console.error(errorMessage);
    }
    receivedMonths(data) {
        const accountsData = this.accountsData.map(accountData => Object.assign({}, accountData));
        const matchingAccount = accountsData.find(accountData => accountData.accountId === data.accountId);
        if (matchingAccount) {
            matchingAccount.months = data.months.map(month => new Month_1.default(month));
            if (matchingAccount.accountNumberTags) {
                const tagsMap = {};
                this.tagCategories.reduce((accum, cat) => accum.concat(cat.tags), []).forEach(tag => tagsMap[tag.id] = tag);
                const accountNumberTagsMap = {};
                matchingAccount.accountNumberTags.forEach(tag => accountNumberTagsMap[tag.account_number] = tag);
                (0, AccountNumberTagUtils_1.addTagsToAccountItems)(matchingAccount.months, tagsMap, accountNumberTagsMap);
            }
            this.flattenAccount(matchingAccount);
            this.accountsData = accountsData;
            this.generateAggregateData();
        }
        else {
            console.error('received months for an account not in the store!');
        }
    }
    loadingMonths() { }
    fetchingMonthsFailed(errorMessage) {
        console.error(errorMessage);
    }
    receivedAccountNumberTags(data) {
        const accountsData = this.accountsData.map(accountData => Object.assign({}, accountData));
        const matchingAccount = accountsData.find(accountData => accountData.accountId === data.accountId);
        if (matchingAccount) {
            matchingAccount.accountNumberTags = data.accountNumberTags.map(accountNumberTag => new AccountNumberTag_1.default(accountNumberTag));
            this.flattenAccount(matchingAccount);
            this.accountsData = accountsData;
            this.generateAggregateData();
        }
        else {
            console.error('received account number tags for an account not in the store!');
        }
    }
    loadingAccountNumberTags() { }
    fetchingAccountNumberTagsFailed(errorMessage) {
        console.error(errorMessage);
    }
    receivedTagCategories(data) {
        this.tagCategories = data.map(it => new TagCategory_1.default(it));
    }
}
const store = (0, createStore_1.default)(GroupAccountsStore, 'GroupAccountsStore');
exports.default = store;
